import { BsModalRef } from "ngx-bootstrap/modal"
import { Component } from "@angular/core"
import { FormBuilder } from "@angular/forms"
import { ResponseStatus } from "app/enums/response-status"
import { ServiceUser } from "app/services/user"
import { ToastrService } from "ngx-toastr"
import { Validators } from "@angular/forms"

@Component({ styleUrls: ["../form.scss"], templateUrl: "index.html" })
export class ModalFeedbackComponent {
  formGroup = this.formBuilder.group({
    content: ["", [Validators.required]],
  })

  loading = false

  constructor(
    private formBuilder: FormBuilder,
    private serviceUser: ServiceUser,
    private toastr: ToastrService,
    public modal: BsModalRef,
  ) {}

  onSubmit() {
    if (this.formGroup.valid) {
      this.loading = true
      this.serviceUser.feedback(this.formGroup.value).subscribe(
        () => {
          this.modal.hide()
          this.toastr.success("We appreciate your feedback", "Thank you!")
        },
        (resp) => {
          const {
            error: { errors = [], ...fields },
            status,
            statusText,
          } = resp
          if (status === ResponseStatus.BAD_REQUEST) {
            for (let field in fields) {
              const f = this.formGroup.get(field)
              if (f) {
                f.setErrors({ ...f.errors, server: fields[field] })
              }
            }
            this.formGroup.setErrors({ ...this.formGroup.errors, server: errors })
          } else {
            this.toastr.error("We will investigate the problem.", `${statusText}`)
            throw new Error(resp)
          }
        },
        () => {
          this.loading = false
        },
      )
    }
  }
}
